import { render } from "./FormHeadTraining.vue?vue&type=template&id=73f9b18d&ts=true"
import script from "./FormHeadTraining.vue?vue&type=script&lang=ts"
export * from "./FormHeadTraining.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__